import React, { ReactNode } from 'react';
import {
  AlertDialog as ChakraAlertDialog,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogProps,
} from '@chakra-ui/react';

interface Props extends AlertDialogProps {
  children: ReactNode;
  closeButton?: boolean;
  noHeader?: boolean;
}

export const AlertDialog = ({ children, ...props }: Props): JSX.Element => {
  return (
    <ChakraAlertDialog {...props}>
      <AlertDialogOverlay>
        <AlertDialogContent
          pt={props.noHeader && props.closeButton ? 12 : props.noHeader ? 4 : 0}
        >
          {props.closeButton && <AlertDialogCloseButton />}
          {children}
        </AlertDialogContent>
      </AlertDialogOverlay>
    </ChakraAlertDialog>
  );
};
export type { Props as AlertDialogProps };
